import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

import { ContentGroupType } from "./content.model";

const GROUPS_ENDPOINT = "v1/content/groups";
const DOCUMENT_GROUPS_ENDPOINT = "v2/content/documentgroups";
const PAGE_TYPES_ENDPOINT = "v2/content/pagetypes";

@Injectable({
	providedIn: "root",
})
export class ContentConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getComponentGroupEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.componentGroup, `${GROUPS_ENDPOINT}`);
	}

	getImagesEndpoint(group: ContentGroupType): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.images, `${GROUPS_ENDPOINT}/${group}-image`);
	}

	getMenuItemEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.menuItem, `${DOCUMENT_GROUPS_ENDPOINT}`);
	}

	getLinkEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.link, `${DOCUMENT_GROUPS_ENDPOINT}/links`);
	}

	/** @deprecated DO NOT USE */
	getPageEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.page, `${PAGE_TYPES_ENDPOINT}/page`);
	}

	getFilteredContentEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.filteredContent, `v3/content/filtered-content`);
	}

	getPromotionEndpoint(): string {
		return this.service.get(
			(x) => x.coreContent.content.endpoints!.promotion,
			`${DOCUMENT_GROUPS_ENDPOINT}/promotion`
		);
	}

	getFlagsEndpoint(): string {
		return this.service.get((x) => x.coreContent.content.endpoints!.flags, `${PAGE_TYPES_ENDPOINT}/flags`);
	}

	getQuicklinkEndpoint(): string {
		return this.service.get(
			(x) => x.coreContent.content.endpoints!.quicklink,
			`${DOCUMENT_GROUPS_ENDPOINT}/quicklink`
		);
	}

	getContentSectionsEndpoint(name: string): string {
		return this.service.get(
			(x) =>
				x.coreContent.content.endpoints!.contentSection &&
				`${x.coreContent.content.endpoints!.contentSection}/${name}`,
			`${DOCUMENT_GROUPS_ENDPOINT}/${name}`
		);
	}

	getGeneralErrorKey(): string {
		return this.service.get((x) => x.coreContent.content.messageKeys!.generalErrorKey, "general.e");
	}

	getGeneralMessageKey(): string {
		return this.service.get((x) => x.coreContent.content.messageKeys!.generalMessageKey, "general.m");
	}

	getIconEndpoint(): string {
		return this.service.get(
			(x) => x.coreContent.content.endpoints!.icons,
			`${DOCUMENT_GROUPS_ENDPOINT}/mobile-common-icons`
		);
	}

	getContentSectionsCacheMaxAge(): number {
		return this.service.get(
			(x) => x.coreContent.content.cacheMaxAge!.contentSection,
			fromMinutesToMilliseconds(15)
		);
	}
}
